<template>
    <div class="notes_convert_to_pdf_wrp" :class="!progressBarEnabled ? 'bg_removed' : ''">
  <div class="progress" style="height:25px;" v-if="progressBarEnabled">
    <div class="progress-bar-striped progress-bar progress-bar-success" :style="{width: `${progress}%`, height:'25px'}">
      {{this.progress}}%</div>
  </div>
  <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="false" :pdf-quality="2" :manual-pagination="true" pdf-format="a4" 
    pdf-orientation="portrait" :html-to-pdf-options="htmlToPdfOptions"
    @progress="onProgress($event)" @beforeDownload="beforeDownload($event)" ref="html2Pdf">
    <div class="notes_pdf_wrp" slot="pdf-content">
      <div class="notes_pdf_logo_wrp">
        <img src="@/assets/images/black_logo_pdf.png">
      </div>
      <div class="blank_space_50"></div>
      <div class="notes_pdf_header_wrp">
        <h1>{{this.notesConvertPdfDATA.title}}</h1>
        <h3>{{this.notesConvertPdfDATA.created_at | dateformat}}</h3>
      </div>
      <div class="notes_pdf_body_wrp">
        <div v-html="this.notesConvertPdfDATA.data" ref="setpdf"></div>
      </div>
    </div>
  </vue-html2pdf>
</div>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import VueHtml2pdf from 'vue-html2pdf'
import {
  bus
} from '@/main';

export default {
  name: 'notes-convert-to-pdf',
  components: {
    VueHtml2pdf
  },
  props: ['notesConvertPdfDATA'],
  data () {
    return {
      progressBarEnabled:true,
      progress: 10,
    }
  },
  computed: {
    htmlToPdfOptions() {
      return {
        margin:[10, 0, 10, 0],
        filename:this.notesConvertPdfDATA.title,
        enableLinks:true,
        image: { type: "jpeg", quality: 1 },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        html2canvas: { scale: 4, useCORS: true, dpi: 192, letterRendering: true }
      };
    },
  },
  mounted () {
    this.generateReport()
  },
  methods: {
    /* Generate Report using refs and calling the
        refs function generatePdf()
    */
    generateReport(){
      this.$refs.html2Pdf.generatePdf()
    },
    onProgress(progress) {
      this.progress = progress;
      // console.log(`PDF generation progress: ${progress}%`)
      if(this.progress == '100'){
        setTimeout(()=>{
          bus.$emit('notesConvertPdfStateBus', false);
          $('body').removeClass('notes_converted_pdf_preview_body');
          this.progressBarEnabled = false
        },3000)
      }
    },
    hasStartedGeneration(ev){
      // console.log(ev, "startPagination Option")
    },
    hasGenerated(ev){
      // console.log(ev, "hasPaginated Option")
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
          await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
              const totalPages = pdf.internal.getNumberOfPages()
              for (let i = 1; i <= totalPages; i++) {
                pdf.setPage(i)
                pdf.setFontSize(12)
                pdf.setTextColor(159,3,3)
                pdf.text('Page ' + i + ' of ' + totalPages, pdf.internal.pageSize.getWidth() - 48, pdf.internal.pageSize.getHeight() - 5)
                pdf.text('www.lymphomap.ai', 22, pdf.internal.pageSize.getHeight() - 5)
              } 
        }).save()
    }
  }
}
</script>

<style lang="scss" scoped>
.notes_convert_to_pdf_wrp {
    z-index: 100;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    padding: 200px 15px;
    &.bg_removed {
        background: none;
    }
    .progress-bar-success {
        background-color: #28a745 !important;
    }
}
.notes_pdf_wrp {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    color: #000000;
    white-space: pre-wrap;
    overflow: visible;
    padding-top: 15px;
    page-break-before: avoid;
    page-break-inside: avoid;
    page-break-after: avoid;
    padding: 0 80px;
    .notes_pdf_logo_wrp {
        width: 100%;
        display: block;
        text-align: left;
        clear: both;
        float: left;
        img {
            float: right;
            width: 260px;
        }
    }
    .notes_pdf_header_wrp{
        h1 {
            font-size: 30px;
            color: #c00000;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
        }
        h3 {
            font-size: 20px;
            color: #666666;
            font-weight: normal;
        }
    }
    .notes_pdf_body_wrp{
        color: #000000;
        overflow: visible;
        font-size: 18px;
        font-weight: normal;
        line-height: 1.25;
    }
    .blank_space_50 {
        height: 50px;
        display: block;
        width: 100%;
    }
}
</style>